/**
 * @created        27/04/2024 - 12:21
 * @author         Parsa Azarshin
 * @user           ragnarok
 * @organization
 * @file-name      dark.js
 * @file-dir       src/plugins/vuetify-options
 */

/** @description config dark theme for vuetify */

/**  to set dark/light theme
 *   @constant
 *   @type {boolean}
 *   @default true
 *  **/
const isDark = true
export default {
  dark: isDark,
  colors: {
    white:"#ffffff",
    black: '#1E1E1E',
    background: "#121212",
    surface: '#212121',
    primary: '#FFAF20',
    'table-active': "#424242",
    btn: "#212121",
    card: '#1A1A1A',
    'primary-darken-1': '#3700B3',
    secondary: '#EEEEEE',
    'secondary-darken-1': '#018786',
    error: '#EF5350',
    info: '#2196F3',
    clBlue: '#036AF5',
    success: '#4CAF50',
    warning: '#FFAF20'
  }
}
